import numeral from "numeral";

export const formatNumber = (
	value: number | null | undefined | string,
	format = "(0,0.00)",
) => {
	return numeral(value).format(format);
};
